import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
const MAX_CARD_WIDTH = { xs: '670px', sm: '484px', md: '384px', lg: '528px' };
const CARD_MARGIN = '12px';
const useStyles = makeStyles()((theme) => ({
    slider: {
        display: 'flex',
        flexDirection: 'row',
    },
    carousel: {
        margin: '0 auto',
        padding: `3px 3px ${spacing.small} 3px`,
    },
    adjustHeadingMargin: {
        paddingBottom: spacing.large,
    },
    carouselItem: {
        margin: 0,
        display: 'flex',
        '& > div': {
            margin: `0 ${CARD_MARGIN}`,
        },
        [theme.breakpoints.down('sm')]: {
            '& > div': {
                margin: '0 auto',
            },
        },
    },
    'custom-dot-list-style': {
        position: 'relative',
        top: '35px',
        '& li:last-child button': {
            marginRight: '0',
        },
    },
    carouselContainer: {
        margin: '0 auto',
        width: '100%',
        maxWidth: `calc(${MAX_CARD_WIDTH.xs} + ${CARD_MARGIN})`,
        [theme.breakpoints.up('sm')]: {
            maxWidth: `calc((${MAX_CARD_WIDTH.sm} + ${CARD_MARGIN}) * 2)`,
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: `calc((${MAX_CARD_WIDTH.lg} + ${CARD_MARGIN}) * 3)`,
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: `calc((${MAX_CARD_WIDTH.lg} + ${CARD_MARGIN}) * 3)`,
        },
    },
    mediaCarousel: {
        padding: `0px 0px ${spacing.xs} 0px`,
        margin: '0 -12px',
        [theme.breakpoints.up('lg')]: {
            padding: `0px 0px ${spacing.medium} 0px`,
        },
    },
    zoomInModal: {
        '& .MuiPaper-root': {
            [theme.breakpoints.up('md')]: {
                padding: '20px 16px 0 20px',
                maxWidth: '960px',
                height: '628px',
                width: '100%',
            },
            [theme.breakpoints.up('xl')]: {
                maxWidth: '1336px',
                height: '840px',
                padding: '32px 31px 44px 32px',
            },
        },
        '& .MuiDialogContent-root': {
            [theme.breakpoints.down('xl')]: {
                display: 'flex',
                alignItems: 'center',
            },
        },
    },
    mediaGalleryItem: {
        margin: 0,
        padding: '0 12px',
    },
}));
export default useStyles;
